import { AnyAction } from 'redux'
import { PmsIntegration, PmsIntegrationErrorCode } from '../../axios/pms/pmsIntegrations/types'
import { SET_PMS_INTEGRATION, SET_PMS_INTEGRATION_ERROR_CODE, SET_PMS_INTEGRATION_IS_SAVING } from '../../actionTypes/pmsIntegration'

export interface PmsIntegrationState {
	integration: PmsIntegration | null
	isSaving: boolean
	errorCode: PmsIntegrationErrorCode | null
}

const initialState: PmsIntegrationState = {
	integration: null,
	isSaving: false,
	errorCode: null,
}

export function pmsIntegrationReducer (state = initialState, action: AnyAction): PmsIntegrationState {
	switch (action.type) {
		case SET_PMS_INTEGRATION:
			return { ...state, integration: action.value }
		case SET_PMS_INTEGRATION_IS_SAVING:
			return { ...state, isSaving: action.value }
		case SET_PMS_INTEGRATION_ERROR_CODE:
			return { ...state, errorCode: action.value }
		default:
			return state
	}
}
